module.exports = __webpack_public_path__ + "static/media/gallerium.732d5036.jpg";